var _linearGradient, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgOrg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450,
    height: 218,
    viewBox: "0 0 450 218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yenu6w5sqb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7273",
    style: {
      fill: "url(#hgtszzhh0a)"
    },
    d: "M0 0h37.12v32.148H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn70bhw5yc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7273",
    style: {
      fill: "url(#hgtszzhh0a)"
    },
    d: "M0 0h37.128v32.155H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9euhvptmgd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7273",
    style: {
      fill: "url(#hgtszzhh0a)"
    },
    d: "M0 0h36.988v32.033H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g6fc85889e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7273",
    style: {
      fill: "url(#hgtszzhh0a)"
    },
    d: "M0 0h37.125v32.152H0z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "hgtszzhh0a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78f11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe6b3f"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10343"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7274",
    transform: "translate(160)",
    style: {
      fill: "#fff",
      stroke: "#d5dadd"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 46,
    rx: 23,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129,
    height: 45,
    rx: 22.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(209 29)",
    style: {
      fill: "#353d45",
      fontSize: 13,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u7E3D\u7D93\u7406\u5BA4"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8179"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8112",
    style: {
      clipPath: "url(#yenu6w5sqb)"
    },
    transform: "translate(164.435 4.339)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5945",
    d: "M15.08 27.768v-2.724a1.424 1.424 0 0 1-.746-.455c-.614-.626-1.083-1.761-1.773-2.589-.566-.711-1.271-.92-1.529-1.674a4.069 4.069 0 0 1-.182-1.376 2.193 2.193 0 0 1 1.033-1.984c0-.889-.033-1.765-.013-2.559a7.619 7.619 0 0 1 .558-3.5 2.693 2.693 0 0 1 1.662-1.433 1.833 1.833 0 0 1 .244-.056c1.416-.4 3.09-.248 4.489-1.19h.837c.992.118 1.04 1.323 1.941 1.666a1.884 1.884 0 0 0 .64.112c.322 0 .6-.056.91-.056a1.363 1.363 0 0 1 .808.229c1.62 1.108.728 4.563.818 6.923.1.44.872.244.99.69a14.9 14.9 0 0 1 0 3.05C23.876 21.6 23.541 23.9 22.005 25c-1.116 4.214 1.715 4.34 4.871 4.987a7.828 7.828 0 0 1 4.324 2.162 18.56 18.56 0 1 0-25.523-.229c2.2-1.914 6.417-1.47 8.656-3.344a3.427 3.427 0 0 0 .746-.808",
    transform: "translate(0 -.001)",
    style: {
      fill: "url(#hgtszzhh0a)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10344"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7274",
    transform: "translate(0 86)",
    style: {
      fill: "#fff",
      stroke: "#d5dadd"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 46,
    rx: 23,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129,
    height: 45,
    rx: 22.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(49 115)",
    style: {
      fill: "#353d45",
      fontSize: 13,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u884C\u653F\u90E8"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8179"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8112",
    style: {
      clipPath: "url(#bn70bhw5yc)"
    },
    transform: "translate(4.436 90.34)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5945",
    d: "M15.083 27.774V25.05a1.425 1.425 0 0 1-.746-.455c-.614-.626-1.083-1.761-1.774-2.59-.566-.711-1.271-.92-1.53-1.674a4.07 4.07 0 0 1-.182-1.377 2.194 2.194 0 0 1 1.034-1.984c0-.889-.033-1.765-.013-2.559a7.62 7.62 0 0 1 .558-3.5 2.693 2.693 0 0 1 1.662-1.437 1.834 1.834 0 0 1 .244-.056c1.416-.4 3.09-.248 4.49-1.191h.837c.992.118 1.04 1.323 1.941 1.666a1.884 1.884 0 0 0 .641.112c.323 0 .6-.056.91-.056a1.363 1.363 0 0 1 .808.229c1.621 1.108.728 4.564.819 6.925.1.44.872.244.99.69a14.905 14.905 0 0 1 0 3.051c-1.891.754-2.226 3.053-3.762 4.161-1.116 4.215 1.716 4.341 4.872 4.988a7.83 7.83 0 0 1 4.325 2.16 18.564 18.564 0 1 0-25.529-.229c2.2-1.914 6.419-1.471 8.658-3.345a3.428 3.428 0 0 0 .746-.808",
    transform: "translate(0 -.001)",
    style: {
      fill: "#d5dadd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10345"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7274",
    transform: "translate(160 86)",
    style: {
      fill: "#fff",
      stroke: "#d5dadd"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 46,
    rx: 23,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129,
    height: 45,
    rx: 22.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(209 115)",
    style: {
      fill: "#353d45",
      fontSize: 13,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u8A2D\u8A08\u90E8"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8179"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8112",
    style: {
      clipPath: "url(#bn70bhw5yc)"
    },
    transform: "translate(164.436 90.34)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5945",
    d: "M15.083 27.774V25.05a1.425 1.425 0 0 1-.746-.455c-.614-.626-1.083-1.761-1.774-2.59-.566-.711-1.271-.92-1.53-1.674a4.07 4.07 0 0 1-.182-1.377 2.194 2.194 0 0 1 1.034-1.984c0-.889-.033-1.765-.013-2.559a7.62 7.62 0 0 1 .558-3.5 2.693 2.693 0 0 1 1.662-1.437 1.834 1.834 0 0 1 .244-.056c1.416-.4 3.09-.248 4.49-1.191h.837c.992.118 1.04 1.323 1.941 1.666a1.884 1.884 0 0 0 .641.112c.323 0 .6-.056.91-.056a1.363 1.363 0 0 1 .808.229c1.621 1.108.728 4.564.819 6.925.1.44.872.244.99.69a14.905 14.905 0 0 1 0 3.051c-1.891.754-2.226 3.053-3.762 4.161-1.116 4.215 1.716 4.341 4.872 4.988a7.83 7.83 0 0 1 4.325 2.16 18.564 18.564 0 1 0-25.529-.229c2.2-1.914 6.419-1.471 8.658-3.345a3.428 3.428 0 0 0 .746-.808",
    transform: "translate(0 -.001)",
    style: {
      fill: "#d5dadd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10346"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7274",
    transform: "translate(320 86)",
    style: {
      fill: "#fff",
      stroke: "#d5dadd"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 46,
    rx: 23,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129,
    height: 45,
    rx: 22.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(368 115)",
    style: {
      fill: "#353d45",
      fontSize: 13,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u7522\u54C1\u898F\u5283\u90E8"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8179"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8112",
    style: {
      clipPath: "url(#9euhvptmgd)"
    },
    transform: "translate(324.419 90.323)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5945",
    d: "M15.026 27.669v-2.714a1.419 1.419 0 0 1-.743-.453c-.612-.624-1.079-1.754-1.767-2.58-.564-.708-1.266-.917-1.524-1.668a4.055 4.055 0 0 1-.181-1.371 2.185 2.185 0 0 1 1.03-1.977c0-.886-.033-1.759-.013-2.55a7.592 7.592 0 0 1 .556-3.484A2.683 2.683 0 0 1 14.04 9.44a1.827 1.827 0 0 1 .243-.056c1.411-.4 3.079-.247 4.473-1.186h.834c.988.117 1.036 1.318 1.934 1.66a1.877 1.877 0 0 0 .638.111c.321 0 .6-.056.906-.056a1.358 1.358 0 0 1 .805.229c1.615 1.1.725 4.547.816 6.9.1.439.869.243.986.688a14.849 14.849 0 0 1 0 3.04c-1.884.752-2.218 3.041-3.748 4.145-1.112 4.2 1.709 4.325 4.854 4.969a7.8 7.8 0 0 1 4.309 2.151 18.494 18.494 0 1 0-25.432-.228c2.188-1.907 6.394-1.465 8.625-3.332a3.415 3.415 0 0 0 .743-.805",
    transform: "translate(0 -.001)",
    style: {
      fill: "#d5dadd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10347"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7274",
    transform: "translate(80 172)",
    style: {
      fill: "#fff",
      stroke: "#d5dadd"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 46,
    rx: 23,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129,
    height: 45,
    rx: 22.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(129 201)",
    style: {
      fill: "#353d45",
      fontSize: 13,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC"
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u5E73\u9762\u8A2D\u8A08\u90E8"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8179"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8112",
    style: {
      clipPath: "url(#g6fc85889e)"
    },
    transform: "translate(84.435 176.339)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5945",
    d: "M15.082 27.772v-2.724a1.425 1.425 0 0 1-.746-.455c-.614-.626-1.083-1.761-1.773-2.59-.566-.711-1.271-.92-1.53-1.674a4.07 4.07 0 0 1-.182-1.377 2.193 2.193 0 0 1 1.034-1.984c0-.889-.033-1.765-.013-2.559a7.62 7.62 0 0 1 .558-3.5 2.693 2.693 0 0 1 1.662-1.437 1.834 1.834 0 0 1 .244-.056c1.416-.4 3.09-.248 4.49-1.191h.837c.992.118 1.04 1.323 1.941 1.666a1.884 1.884 0 0 0 .641.112c.322 0 .6-.056.91-.056a1.363 1.363 0 0 1 .808.229c1.621 1.108.728 4.564.819 6.924.1.44.872.244.99.69a14.9 14.9 0 0 1 0 3.051c-1.891.754-2.226 3.053-3.762 4.161-1.116 4.215 1.715 4.341 4.872 4.988a7.829 7.829 0 0 1 4.318 2.163 18.562 18.562 0 1 0-25.527-.229c2.2-1.914 6.418-1.471 8.657-3.345a3.427 3.427 0 0 0 .746-.808",
    transform: "translate(0 -.001)",
    style: {
      fill: "#d5dadd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10348"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 7274",
    transform: "translate(240 172)",
    style: {
      fill: "#fff",
      stroke: "#d5dadd"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 46,
    rx: 23,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129,
    height: 45,
    rx: 22.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(289 201)",
    style: {
      fill: "#353d45",
      fontSize: 13,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC"
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u4E92\u52D5\u8A2D\u8A08\u90E8"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8179"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8112",
    style: {
      clipPath: "url(#bn70bhw5yc)"
    },
    transform: "translate(244.436 176.34)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5945",
    d: "M15.083 27.774V25.05a1.425 1.425 0 0 1-.746-.455c-.614-.626-1.083-1.761-1.774-2.59-.566-.711-1.271-.92-1.53-1.674a4.07 4.07 0 0 1-.182-1.377 2.194 2.194 0 0 1 1.034-1.984c0-.889-.033-1.765-.013-2.559a7.62 7.62 0 0 1 .558-3.5 2.693 2.693 0 0 1 1.662-1.437 1.834 1.834 0 0 1 .244-.056c1.416-.4 3.09-.248 4.49-1.191h.837c.992.118 1.04 1.323 1.941 1.666a1.884 1.884 0 0 0 .641.112c.323 0 .6-.056.91-.056a1.363 1.363 0 0 1 .808.229c1.621 1.108.728 4.564.819 6.925.1.44.872.244.99.69a14.905 14.905 0 0 1 0 3.051c-1.891.754-2.226 3.053-3.762 4.161-1.116 4.215 1.716 4.341 4.872 4.988a7.83 7.83 0 0 1 4.325 2.16 18.564 18.564 0 1 0-25.529-.229c2.2-1.914 6.419-1.471 8.658-3.345a3.428 3.428 0 0 0 .746-.808",
    transform: "translate(0 -.001)",
    style: {
      fill: "#d5dadd"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 437",
    transform: "translate(225.5 46)",
    style: {
      stroke: "#707070",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v40"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 438",
    transform: "translate(225 132)",
    style: {
      stroke: "#707070",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v20"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10349"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 440",
    transform: "translate(315 152)",
    style: {
      stroke: "#707070",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v20"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 441",
    transform: "translate(136 152)",
    style: {
      stroke: "#707070",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v20"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 439",
    transform: "translate(135.5 153)",
    style: {
      stroke: "#707070",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h180"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10350"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 440",
    transform: "translate(385 66)",
    style: {
      stroke: "#707070",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v20"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 441",
    transform: "translate(66 66)",
    style: {
      stroke: "#707070",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v20"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 439",
    transform: "translate(65 67)",
    style: {
      stroke: "#707070",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h320"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOrg);
export default __webpack_public_path__ + "static/media/img_org.3bab016926bc4252e3cf5a2f2510fb2f.svg";
export { ForwardRef as ReactComponent };